import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ComboDetails from './pages/ComboDetails';
import BoxSidebar from './components/BoxSidebar';
import { BoxProvider } from './context/BoxContext';

/**
 * Componente raíz de la aplicación mejorado con animaciones.
 * Aquí se definen las rutas principales y se incorporan el encabezado,
 * el pie de página y el sidebar de la caja que persisten entre vistas.
 */
function App() {
  return (
    <BoxProvider>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/combo/:id" element={<ComboDetails />} />
            {/* Ruta fallback: redireccionar a inicio si la ruta no existe */}
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <Footer />

        {/* Sidebar de la caja - accesible desde cualquier página */}
        <BoxSidebar />
      </div>
    </BoxProvider>
  );
}

export default App;